import Hosts from '../../Hosts';

//const object_type = 'Content'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/app/notes`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/app/notes/${companycode}`

const base_endpoint = '/app_notes'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        type: 'note',
        layout: 'normal',
        date: {
            creation: '',
            published: '',
            avaiable: '',
            notification: '',
            modified: []
        },
        language: [],
        media: {
            id: '',
            link: '',
        },  
        seo: {
            title: '',
            description: '',
            keywords: '',
            language: []
        }, 
        tags: [],
        parent: '0',
        order: '1',
        slug: '',  
        status: 'under_review',
        notified: false
    },
    content: [{
        
        name: '',
        email: '',
        address: '',
        message: '',
        media: {
            image: [],
            doc: []
        }
    }]
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
